namespace Areas.Reviewers {
    "use strict";


    export function gotoVendorProfile() {
        const mainForm = $("#ContractVendorLinkForm").dxForm("instance");
        const values: any = mainForm.option("formData");
        const result: any = mainForm.validate();
        var vendorId = mainForm.option("VendorId");

        var linkInfo = "/Vendor/ViewPrint/Index/" + vendorId;
        location.href = linkInfo;

    }

    export function saveContractLink() {
        const mainForm = $("#ContractVendorLinkForm").dxForm("instance");
        const values: any = mainForm.option("formData");
        const result: any = mainForm.validate();
        var vendorId = mainForm.option("VendorId");

        if (result.isValid) {
            sendRequest(`/Reviewers/ContractLink/Put/${vendorId}`, JSON.stringify(values), "PUT");
        }

    }

    export function updateContract() {
        const mainForm = $("#ContractVendorLinkForm").dxForm("instance");
        var vendorId = mainForm.option("VendorId");

        sendRequest(`/Reviewers/ContractLink/UpdateContract/${vendorId}`, "", "POST");
        
    }

    export function deleteContractVendorLink() {
        const verifyDelete = window.confirm("Are you sure you would like to DELETE the Link record?");

        if (verifyDelete) {
            const mainForm = $("#ContractVendorForm").dxForm("instance");
            const values: any = mainForm.option("formData");
            const result: any = mainForm.validate();
            var contractVendorLinkId = mainForm.option("ContractVendorLinkId");

            if (contractVendorLinkId != null) {
                sendRequest(`/Reviewers/ContractLink/Delete/${contractVendorLinkId}`, "", "DELETE");
            }
        }
    }

    export function showVendorPopup() {
        $("#VendorLookupPopup").dxPopup("instance").show();
    }

    export function cancelSelectVendor() {
        $("#VendorLookupPopup").dxPopup("instance").hide();
    }

    export function selectVendor(e) {
        var dataGrid = $('#VendorLookupGrid').dxDataGrid('instance');
        var selectedRow: any = dataGrid.getSelectedRowsData();

        if (selectedRow[0] == null) {
            DevExpress.ui.notify("You need to select a Vendor first!", "warning", 2000);
        } else {

            var dataId = selectedRow[0].vendorId;

            var newName = selectedRow[0].vendorName;
            var newLicense = selectedRow[0].caLicenseNumber;
            var newTax = selectedRow[0].taxID;
            var newDir = selectedRow[0].dirNumber;

            //the lookup form for display and lookup only

            var lookupForm = $("#ContractVendorLookupForm").dxForm("instance");
            //update control values
            var nameControl: DevExpress.ui.dxTextBox = lookupForm.getEditor('ContractVendorName') as DevExpress.ui.dxTextBox;
            nameControl.option("value", newName);

            var licenseControl: DevExpress.ui.dxTextBox = lookupForm.getEditor('CALicenseNumber') as DevExpress.ui.dxTextBox;
            licenseControl.option("value", newLicense);

            var taxControl: DevExpress.ui.dxTextBox = lookupForm.getEditor('TaxID') as DevExpress.ui.dxTextBox;
            taxControl.option("value", newTax);

            var dirControl: DevExpress.ui.dxTextBox = lookupForm.getEditor('DIRNumber') as DevExpress.ui.dxTextBox;
            dirControl.option("value", newDir);


            //this is the main form _EditForm.cshtml
            var dataForm: DevExpress.ui.dxForm = $('#ContractLinkForm').dxForm('instance');
            var newData: any = dataForm.option('formData');

            newData.ContractVendorId = dataId;

            $("#VendorLookupPopup").dxPopup("instance").hide();
        }

    }

    export function showMissingInfoPopup() {
        $("#VendorMissingInfoPopup").dxPopup("instance").show();
    }

    export function closePopup() {
        $("#VendorMissingInfoPopup").dxPopup("instance").hide();
    }

}
